import React from 'react';
import { FrontEdgeLogo } from '../../../../components/icons';
import { ARMIcon } from '../../../../components/icons/TreasurySplashScreenImage';
import Button from '../../../../components/button/Button';
import { useNavigate } from 'react-router-dom';

const SplashStep3 = ({
    setShowSplash
}: {
    setShowSplash: (val: boolean) => void;
}) => {
    const navigate = useNavigate();
    return (
        <div className='w-full space-y-6 relative'>
            <FrontEdgeLogo size='120' />
            <div className=' mt-4 w-full text-center flex-col flex items-center'>
                <ARMIcon />

                <p className='text-deepMidnightBlue text-lg pb-8 text-center '>
                    We found your company in ARM’s system. <br />
                    Link this account to Frontedge?
                </p>

                <Button
                    onClick={() => {
                        navigate('/investment/portfolio');
                        setShowSplash(false);
                    }}
                    text='Continue'
                    className='w-full'
                />
            </div>
        </div>
    );
};

export default SplashStep3;
